var _path, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrinter = function SvgPrinter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Ebene 1",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 12.2h-7.43v-6a1 1 0 0 0-1-1h-18.9a1 1 0 0 0-1 1v6H9.62a2 2 0 0 0-1.41.59l-1.58 1.58A2 2 0 0 0 6 15.78v16.1a1 1 0 0 0 1 1h7.5v10.93a1 1 0 0 0 1 1h18.91a1 1 0 0 0 1-1V32.88H43a1 1 0 0 0 1-1V13.2a1 1 0 0 0-1-1M17.47 7.49h15.3a.5.5 0 0 1 .5.5v4.21H17V8a.5.5 0 0 1 .47-.51m15.14 35H17.34a.5.5 0 0 1-.5-.5V26.46a.51.51 0 0 1 .5-.5h15.27a.5.5 0 0 1 .5.5V42a.5.5 0 0 1-.5.51zm8.55-11.93h-5.75v-5.9a1 1 0 0 0-1-1H15.54a1 1 0 0 0-1 1v5.92h-5.7a.5.5 0 0 1-.5-.5V15.5a1 1 0 0 1 1-1h31.82a.5.5 0 0 1 .5.5v15.08a.5.5 0 0 1-.5.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11.56,
    height: 2.3,
    x: 19.2,
    y: 28.92,
    rx: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 11.56,
    height: 2.3,
    x: 19.2,
    y: 33.09,
    rx: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 11.56,
    height: 2.3,
    x: 19.2,
    y: 37.26,
    rx: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.3,
    height: 2.3,
    x: 37.46,
    y: 16.67,
    rx: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.3,
    height: 2.3,
    x: 33.43,
    y: 16.67,
    rx: 0.5
  })));
};
export default SvgPrinter;